/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from 'react-redux';
import { deleteUser } from '../../apis/profile';
import { useMutation } from '@tanstack/react-query';
import { clearAuthData } from '../../redux/slices/authSlice';
import { triggerSnackbar } from '../../provider/SnackbarProvider';

// Define the hook
const useDeleteUser = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationKey: ['delete-user'],
    mutationFn: async (userId: any) => {
      await deleteUser(userId);
    },
    onSuccess: () => {
      localStorage.clear();
      dispatch(clearAuthData());

      triggerSnackbar({
        message: 'Your account has been successfully deleted.',
        severity: 'success',
      });
    },
  });
};

export default useDeleteUser;
